
import React, { useState } from 'react';
import { Grid, TextField, FormControlLabel, Checkbox, Box, Typography, FormControl, InputLabel, Select, MenuItem, Button, FormGroup, FormLabel } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

function ViewTechnician() {
    const [isLoading ] = useState(false);
    const navigate = useNavigate();

    const location = useLocation();
    const { technician } = location.state || {};
    const options = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]

    return (
        <div>
            <h1 className="page-header">View Technician</h1>
            <form className="job-order-form">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={5}>
                                <FormControl fullWidth>
                                    <InputLabel id="team-label" sx={{ fontSize: '0.875rem' }}>
                                        Team
                                    </InputLabel>
                                    <Select
                                        labelId="team-label"
                                        name="type"
                                        value={technician.team}
                                        label="Team"
                                        sx={{ fontSize: '0.875rem' }}
                                        disabled
                                    >
                                        <MenuItem value="Delta">Delta</MenuItem>
                                        <MenuItem value="Sigma">Sigma</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={5}>
                                <TextField
                                    name="firstname"
                                    label="Firstname"
                                    value={technician.firstname}
                                    fullWidth
                                    disabled
                                    InputProps={{ sx: { fontSize: '0.875rem' } }}
                                    InputLabelProps={{ sx: { fontSize: '0.875rem' } }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={5}>
                                <TextField
                                    name="lastname"
                                    label="Lastname"
                                    value={technician.lastname}
                                    fullWidth
                                    disabled
                                    InputProps={{ sx: { fontSize: '0.875rem' } }}
                                    InputLabelProps={{ sx: { fontSize: '0.875rem' } }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <FormGroup>
                                    <FormLabel component="legend">Rest Day</FormLabel>
                                    <Grid container spacing={2}>
                                        {options.map((option) => (
                                            <Grid item xs={3} key={option}> {/* Each item takes up half the width (2 per row) */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={technician.rest_day.includes(option)}
                                                            value={option}
                                                        />
                                                    }
                                                    label={option}
                                                    disabled
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Form buttons */}
                    <Grid item xs={12}>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => navigate('/manage-technicians')}
                            sx={{ fontSize: '0.875rem' }}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
}

export default ViewTechnician;
